export default "__VITE_ASSET__ef104117__"